import { gql } from "@apollo/client";

export const QUERY_GET_DOCUMENT_TYPES = gql`
  query QUERY_GET_DOCUMENT_TYPES {
    enDocumentType {
      comment
      value
    }
  }
`